<template>
  <div class="home">
    <div>temp route</div>
    <div>
      <router-link to="/login">Go to Login</router-link>
    </div>
    <div>
      <router-link to="/list">Go to List</router-link>
    </div>
    <div>
      <router-link to="/table">Go to Table</router-link>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',
  components: {
  },
  created() {
    const userInfo = this.$store.state.userInfo
    if(userInfo) {
      this.$router.push('/list')
    } else {
      this.$router.push('/login')
    }
  },
  methods: {
  }
  
}
</script>
<style lang="less">
.home {
  height: 100%;
  position: relative;
  background: url('~@/assets/background.png');
}
</style>
